import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/gi-girl-icon.svg'
import _imports_1 from '../../assets/images/mails-img.svg'


const _withScopeId = n => (_pushScopeId("data-v-25351a8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "agency-creation-flow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Agency Creation", -1))
const _hoisted_3 = { class: "steeps-list" }
const _hoisted_4 = { class: "steep-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-steep" }, "Agency Info", -1))
const _hoisted_6 = { class: "steep-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-steep" }, "Invite Influencers", -1))
const _hoisted_8 = { class: "steep-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-steep" }, "Confirmation", -1))
const _hoisted_10 = {
  key: 0,
  class: "p-pt-6",
  style: {"flex-grow":"1"}
}
const _hoisted_11 = { class: "p-d-flex p-flex-wrap p-mt-6" }
const _hoisted_12 = { class: "p-d-flex p-mr-5" }
const _hoisted_13 = { class: "main-photo-block" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Profile image", -1))
const _hoisted_15 = {
  key: 0,
  src: _imports_0,
  class: "user-photo"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "select synced image", -1))
const _hoisted_18 = { class: "p-d-flex" }
const _hoisted_19 = ["onClick", "src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload" }, null, -1))
const _hoisted_21 = { class: "p-ml-auto" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "AGENCY name", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "About you", -1))
const _hoisted_24 = {
  key: 1,
  style: {"flex-grow":"1"},
  class: "block-two"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-mt-6" }, "Build your community", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create a community of influencers that have the same interests and chase opportunities together.", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Username or email", -1))
const _hoisted_28 = { class: "search-block" }
const _hoisted_29 = {
  key: 0,
  class: "channel-list"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "RECENTLY VIEWED", -1))
const _hoisted_31 = { class: "p-d-flex p-align-center" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "share-registy-link" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Share a registration link", -1))
const _hoisted_35 = { class: "share-block" }
const _hoisted_36 = {
  key: 2,
  class: "block-three"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-mt-6" }, "Please confirm your Agency Account", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"max-width":"790px"} }, "We have sent a confirmation email for your new Agency Account. Please follow the link from the email to confirm your account.", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_40 = [
  _hoisted_37,
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = { class: "actions-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["number-steep", _ctx.currentSteep === 1 ? 'number-steep-active' : null])
        }, "01", 2),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["number-steep", _ctx.currentSteep === 2 ? 'number-steep-active' : null])
        }, "02", 2),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(["number-steep", _ctx.currentSteep === 3 ? 'number-steep-active' : null])
        }, "03", 2),
        _hoisted_9
      ])
    ]),
    (_ctx.currentSteep === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                (!_ctx.selectedPhoto)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.selectedPhoto,
                      class: "user-photo"
                    }, null, 8, _hoisted_16))
              ]),
              _createElementVNode("div", null, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePhotos, (photo, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      class: _normalizeClass(["photo-item", [_ctx.selectedPhoto === photo ? 'active' : '']]),
                      onClick: ($event: any) => (_ctx.selectedPhoto = photo),
                      src: photo,
                      key: `${index}_ph`
                    }, null, 10, _hoisted_19))
                  }), 128)),
                  _createElementVNode("label", null, [
                    _createElementVNode("input", {
                      type: "file",
                      name: "photo",
                      accept: "image/*",
                      ref: "uploadPhotoInput",
                      id: "Image",
                      style: {"visibility":"hidden","display":"none"},
                      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFileUpload()))
                    }, null, 544),
                    _hoisted_20
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                placeholder: "Enter agency name...",
                class: "w-100 tittle-input"
              }, null, 8, ["modelValue"]),
              _hoisted_23,
              _createVNode(_component_Textarea, {
                class: "textarea",
                modelValue: _ctx.aboutAgency,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.aboutAgency) = $event)),
                autoResize: false,
                placeholder: "Type here...",
                rows: "6",
                cols: "30"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentSteep === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _hoisted_25,
          _hoisted_26,
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_InputText, {
              class: "input-search",
              onKeydown: _withKeys(_ctx.addCreator, ["enter"]),
              type: "text",
              modelValue: _ctx.forUsername,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.forUsername) = $event)),
              placeholder: "Search for influencers"
            }, null, 8, ["onKeydown", "modelValue"]),
            _createVNode(_component_Button, {
              label: "SEND INVITE",
              class: "gi-button",
              loading: _ctx.searchChannelLoading,
              onClick: _ctx.addCreator
            }, null, 8, ["loading", "onClick"])
          ]),
          (_ctx.searchResult && _ctx.searchResult.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _hoisted_30,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResult, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "channel-item",
                    key: `${index}_c_i`
                  }, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("img", {
                        src: item?.snippet?.thumbnails?.default?.url
                      }, null, 8, _hoisted_32),
                      _createElementVNode("span", null, _toDisplayString(item?.snippet?.channelTitle), 1)
                    ]),
                    _createVNode(_component_Button, {
                      label: _ctx.isChannelAlredyAdded(_ctx.channels?.channel?.items, item?.id?.channelId)
           ? 'DELETE' : 'INVITE',
                      class: "p-button-text invite-btn",
                      onClick: ($event: any) => (!_ctx.isChannelAlredyAdded(_ctx.channels?.channel?.items, item?.id?.channelId)
                   ? _ctx.selectChannelForAdd(item) : _ctx.deleteChanel(item?.id?.channelId, index))
                    }, null, 8, ["label", "onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("span", null, _toDisplayString(_ctx.regPath), 1),
              _createVNode(_component_Button, {
                label: "Copy Link",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyLink(_ctx.regPath))),
                class: ""
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentSteep === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_40))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_41, [
      _createVNode(_component_Button, {
        label: "Cancel",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentSteep > 1 ? _ctx.currentSteep -= 1 : _ctx.$router.back())),
        class: "p-button-text cancel-text"
      }),
      (_ctx.currentSteep < 3)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Continue",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.currentSteep += 1)),
            class: "continue-btn",
            disabled: !_ctx.computedProcess
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_ctx.currentSteep === 3)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: "Confirm",
            class: "continue-btn",
            onClick: _ctx.confirmAgency
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}